import { ORDER_ACTION_TYPE } from '@/api/type/commonTypes';
import { TFunction } from 'i18next';

export const formatPartnerAlarmMsg = (
  actionType: ORDER_ACTION_TYPE,
  t: TFunction
) => {
  switch (actionType) {
    case 'ORDER_RECEIPT':
      return t('newOrderReceived');
    case 'ORDER_ACCEPT':
      return t('orderReceivedInProgressPartner');
    case 'ORDER_REJECT':
      return t('orderWasRejected');
    case 'ORDER_CANCEL':
      return t('orderCancelled');
    case 'PARTNER_CONFIRM':
      return t('designDiagnosisFileUploadedSuccessfully');
    case 'PLAYER_CONFIRM':
      return t('confirmRevisionFileUploadedSuccessfully');
    case 'PARTNER_CONFIRM_FILE_DELETE':
      return t('theDesignDiagnosisFileHasBeenDeleted');
    case 'ORDER_COMPLETE':
      return t('orderCompleted2');
  }
};
